import React, { useEffect, useState } from "react";

import CodeMirror from "@uiw/react-codemirror";
import { Formik, Form } from "formik";

import { Typography, Button, Modal } from "clearsense-ui/components";
import { Select } from "clearsense-ui/components/formik";

import Tabs from "./Tabs";

import { AGGREGATE_FUNCTIONS } from "../../../constants";
import { modalValidationSchema } from "../../../validations";

const MetricModal = ({
  modalRef,
  formRef,
  showModal,
  tableDetails,
  theme,
  setShowModal,
}) => {
  const [currentTab, setCurrentTab] = useState("simple");
  const [customSQL, setCustomSQL] = useState("");

  useEffect(() => {
    if (showModal) {
      setCurrentTab("simple");
      setCustomSQL("");
    }
  }, [showModal]);

  return (
    <Formik
      enableReinitialize
      innerRef={modalRef}
      initialValues={{ column: "", aggregate: "", test: "" }}
      validationSchema={currentTab === "simple" ? modalValidationSchema : null}
      onSubmit={val => {
        const metricValues =
          currentTab === "simple"
            ? {
                label: `${val.aggregate.value}${val.column.value})`,
                value: `${val.aggregate.value}${val.column.value})`,
              }
            : {
                label: customSQL,
                value: customSQL,
              };

        formRef.current.setFieldValue("valuekey", [
          ...(formRef.current.values.valuekey
            ? [...formRef.current.values.valuekey]
            : []),
          { ...metricValues },
        ]);
      }}
    >
      {formik => (
        <Form>
          <Modal
            isOpen={showModal}
            closeButton={false}
            onClose={() => setShowModal(false)}
            className="metric-modal"
            backdropClassName="chart-modal-backdrop"
          >
            <Modal.Body>
              <Typography style="h3" className="mt-6 font-bold">
                Add Metric
              </Typography>
              <Tabs currentTab={currentTab} setCurrentTab={setCurrentTab} />
              {currentTab === "simple" ? (
                <div className="flex flex-col space-y-4">
                  <Select
                    required
                    label="Column"
                    name="column"
                    data-cy="metric-column-select-field"
                    placeholder="Select a column"
                    noOptionsMessage={() => (
                      <span className="dark:text-shade-light">
                        Please select a database table first
                      </span>
                    )}
                    options={
                      formRef.current?.values?.["table"]
                        ? tableDetails.map(columnName => ({
                            label: columnName[0],
                            value: columnName[0],
                          }))
                        : []
                    }
                  />
                  <Select
                    required
                    label="Aggregate"
                    name="aggregate"
                    data-cy="metric-aggregate-select-field"
                    placeholder="Select an aggregate function"
                    options={AGGREGATE_FUNCTIONS}
                  />
                </div>
              ) : (
                <div
                  style={{
                    height: "140px",
                  }}
                >
                  <CodeMirror
                    name="test"
                    value={customSQL}
                    width="100%"
                    height="138px"
                    className="border"
                    theme={theme}
                    onChange={setCustomSQL}
                  />
                </div>
              )}
            </Modal.Body>
            <Modal.Footer className="space-x-2">
              <Button
                label="Add"
                size="large"
                data-cy="add-metric-submit-button"
                disabled={currentTab === "customSQL" && !customSQL}
                onClick={() => {
                  formik.submitForm();
                  if (
                    (formik.isValid && formik.dirty) ||
                    currentTab === "customSQL"
                  ) {
                    setShowModal(false);
                  }
                }}
              />
              <Button
                style="text"
                label="Cancel"
                data-cy="add-metric-cancel-button"
                onClick={() => setShowModal(false)}
                size="large"
              />
            </Modal.Footer>
          </Modal>
        </Form>
      )}
    </Formik>
  );
};

export default MetricModal;
